export const calculateTotalPriceOfProductBox = (product, currentProduct) => {
  const amountOfIncrease = currentProduct.increase_amount;

  const productPrice = !currentProduct.full_price
    ? product?.full_price
    : currentProduct.full_price;

  const fullPriceProduct = product?.full_price && productPrice;

  return Number(amountOfIncrease) * Number(fullPriceProduct);
};
